module.exports = new __parcel__URL__("acquisition-offer.a3d26474.png").toString();